<template>
  <div class="search-form search-form--more-days" :class="{ isFlat: isFlat }">
    <v-form
      ref="form"
      v-model="form.valid"
      class="flex items-center"
      :class="{ 'justify-between': !isFlat, 'destiny-search': isDestinySearch }"
    >
      <div
        class="input-container origin"
        :class="{
          'w-full md:w-1/2 xl:w-full': !isFlat && !isDestinySearch,
          'w-full': !isFlat && isDestinySearch,
          'md:px-2': !isDestinySearch,
        }"
      >
        <label v-if="!isFlat && !isDestinySearch">{{ $t('shared.where_from') }}</label>
        <v-select
          class="js-prepend-custom-icons js-replace-arrows"
          height="50"
          v-model="origin"
          :items="originsOptions"
          prepend-inner-icon="airplane"
          :placeholder="$t('shared.where_from')"
          outlined
          rounded
          single-line
          background-color="#fff"
          :disabled="form.loading || loading"
          :error="searchValues.origin === null && form.showErrors"
          item-text="label"
          item-value="code"
          :no-data-text="`${$t('shared.loading_cities')}...`"
        ></v-select>
      </div>
      <div
        class="input-container travellers max-width-people"
        :class="{
          'w-full md:w-1/2 xl:w-full fix-width': !isFlat && !isDestinySearch,
          'w-full': isDestinySearch,
          'md:px-2': !isDestinySearch,
        }"
      >
        <label v-if="!isFlat && !isDestinySearch">{{ ucfirst($tc('shared.person', 2)) }}</label>
        <v-menu
          v-if="!isMobileMixin"
          v-model="form.showTravellersMenu"
          content-class="avm-menu avm-travellers-menu"
          attach=".input-container.travellers"
          transition="scale-transition"
          :min-width="!isDestinySearch ? '240px' : '353px'"
          :offset-y="true"
          :close-on-content-click="false"
          :bottom="true"
          :disabled="form.loading || loading"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="travellersLabel"
              height="50"
              class="
                avm-text-field avm-text-field--travellers
                max-width-people
                js-prepend-custom-icons js-replace-arrows
              "
              :class="{ 'dropdown-arrow-rotated': form.showTravellersMenu }"
              prepend-inner-icon="user"
              append-icon="dropdown-arrow"
              background-color="#fff"
              :placeholder="travellersLabel"
              persistent-hint
              rounded
              readonly
              outlined
              v-bind="attrs"
              v-on="on"
              :disabled="form.loading || loading"
            ></v-text-field>
          </template>
          <div class="counter-container">
            <p class="counter-title">{{ ucfirst($tc('shared.adult', 2)) }}</p>
            <app-counter
              v-on:change="handleTravellersUpdate"
              field-name="adults"
              :value="travellers.adults"
            >
            </app-counter>
          </div>
          <div class="counter-container">
            <div>
              <p class="counter-title">{{ ucfirst($tc('shared.child', 2)) }}</p>
              <p class="hint">2-16 {{ $t('shared.years') }}</p>
            </div>
            <app-counter
              v-on:change="handleTravellersUpdate"
              field-name="childs"
              :value="travellers.childs"
            >
            </app-counter>
          </div>
          <div class="counter-container">
            <div>
              <p class="counter-title">{{ ucfirst($tc('shared.baby', 2)) }}</p>
              <p class="hint">1-2 {{ $t('shared.years') }}</p>
            </div>
            <app-counter
              v-on:change="handleTravellersUpdate"
              field-name="babies"
              :value="travellers.babies"
            >
            </app-counter>
          </div>
          <div class="flex items-center justify-end">
            <v-btn
              text
              color="secondary"
              elevation="0"
              :ripple="false"
              class="paragraph-h-16"
              @click.stop="form.showTravellersMenu = false"
            >
              {{ ucfirst($t('shared.ready')) }}
              <v-icon right size="20"> mdi-chevron-right </v-icon>
            </v-btn>
          </div>
        </v-menu>
        <v-dialog
          v-model="showDialog"
          v-if="isMobileMixin"
          fullscreen
          hide-overlay
          max-width="100vw"
          transition="dialog-bottom-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="travellersLabel"
              height="50"
              class="avm-text-field avm-text-field--travellers"
              prepend-inner-icon="perm_identity"
              :placeholder="travellersLabel"
              background-color="#fff"
              persistent-hint
              rounded
              readonly
              outlined
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-card>
            <v-toolbar elevation="0">
              <v-btn icon dark @click="showDialog = false">
                <v-icon color="black">mdi-close</v-icon>
              </v-btn>
              <h3 class="heading-3">{{ $t('shared.number_of_people') }}</h3>
            </v-toolbar>
            <div class="dialog-content">
              <div class="counter-container">
                <p class="counter-title">{{ $tc('shared.adult', 2) }}</p>
                <app-counter
                  v-on:change="handleTravellersUpdate"
                  field-name="adults"
                  :value="travellers.adults"
                >
                </app-counter>
              </div>
              <div class="counter-container">
                <p class="counter-title">{{ $tc('shared.child', 2) }}</p>
                <p class="hint">2-16 {{ $t('shared.years') }}</p>
                <app-counter
                  v-on:change="handleTravellersUpdate"
                  field-name="childs"
                  :value="travellers.childs"
                >
                </app-counter>
              </div>
              <div class="counter-container">
                <p class="counter-title">{{ $tc('shared.baby', 2) }}</p>
                <p class="hint">0-2 {{ $t('shared.years') }}</p>
                <app-counter
                  v-on:change="handleTravellersUpdate"
                  field-name="babies"
                  :value="travellers.babies"
                >
                </app-counter>
              </div>
            </div>
            <v-btn
              rounded
              elevation="0"
              color="secondary"
              class="avm-btn dialog-done pl-10 -mt-1"
              width="95%"
              @click="showDialog = false"
              >{{ $t('shared.ready') }}</v-btn
            >
          </v-card>
        </v-dialog>
      </div>
      <template v-if="!isDestinySearch">
        <div
          class="input-container date-container relative"
          :class="{
            'w-full md:w-1/2 xl:w-full fix-width': !isFlat,
            'md:px-2': !isDestinySearch,
          }"
        >
          <date-range-picker
            v-model="value"
            :date-format="dateFormat"
            :ranges="false"
            @startSelection="outgoingSelected"
            @toggle="toggleCalendar"
            @finishSelection="selectingReturn = false"
            :auto-apply="!isMobileMixin"
            :locale-data="localeData"
          >
            <template #input="startDate" style="min-width: 350px">
              <div class="flex flex-col">
                <label v-if="!isFlat && !isDestinySearch">{{ $t('shared.outbound_trip') }}</label>
                <v-text-field
                  v-model="moreDaysStartText"
                  height="50"
                  class="
                    avm-text-field avm-text-field--moredates
                    max-width-date
                    js-prepend-custom-icons js-replace-arrows
                    mr-2
                  "
                  :class="{ 'rounded-select-selected': selectingOutgoing }"
                  prepend-inner-icon="calendar"
                  append-icon="dropdown-arrow"
                  background-color="#fff"
                  :placeholder="moreDaysStartText"
                  persistent-hint
                  rounded
                  readonly
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  :error="form.showErrors && datesAreInvalid"
                  :disabled="form.loading || loading"
                ></v-text-field>
              </div>
              <div class="flex flex-col items-end md:items-start">
                <label v-if="!isFlat && !isDestinySearch">{{ ucfirst($t('shared.inbound_trip')) }}</label>
                <v-text-field
                  v-model="moreDaysEndText"
                  height="50"
                  class="
                    avm-text-field avm-text-field--moredates
                    max-width-date
                    js-prepend-custom-icons js-replace-arrows
                  "
                  :class="{ 'rounded-select-selected': selectingReturn }"
                  prepend-inner-icon="calendar"
                  background-color="#fff"
                  append-icon="dropdown-arrow"
                  :placeholder="moreDaysEndText"
                  persistent-hint
                  rounded
                  readonly
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  :error="form.showErrors && datesAreInvalid"
                  :disabled="form.loading || loading"
                ></v-text-field>
              </div>
            </template>
            <div slot="footer" slot-scope="data" class="slot">
              <div class="text-center mb-10">
                <span
                  @click="data.clickApply"
                  class="
                    avm-btn
                    w-full
                    v-btn v-btn--rounded
                    theme--light
                    elevation-0
                    v-size--default
                    secondary
                    lg:hidden
                  "
                >
                  {{ $t('shared.search') }}
                </span>
              </div>
            </div>
          </date-range-picker>
        </div>
      </template>
      <div
        class="btn-container"
        :class="{
          'w-full md:w-1/2 xl:w-full': !isFlat && !isDestinySearch,
          'w-full': isDestinySearch,
          'md:px-2': !isDestinySearch,
        }"
      >
        <v-btn
          class="avm-btn w-full search-style"
          color="secondary"
          rounded
          elevation="0"
          :loading="form.loading || loading"
          :disabled="isDestinySearch && searchValues.origin === null"
          @click="search(searchType)"
        >
          {{ ucfirst(isDestinySearch ? $t('shared.reserve') : $t('shared.search')) }}
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import moment from "moment";
import searcherMixin from "../../mixins/searcherMixin";
import prependCustomIcons from "../../../../utils/mixins/prependCustomIcons";
import replaceArrows from "../../../../utils/mixins/replaceArrows";
import {
  SET_SEARCH_MORE_START_DATE,
  SET_SEARCH_MORE_END_DATE,
  SET_SEARCH_ORIGIN,
} from "../../../../store/search/mutation-types";
import { GET_MORE_THAN_ONE_DAY_ORIGINS_OPTIONS } from "../../../../store/destinies/getter-types";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { ucfirst } from '../../../../utils/strings';
import { monthNames, daysOfTheWeek } from '../../../../utils/trans';

export default {
  mixins: [searcherMixin, prependCustomIcons, replaceArrows],
  components: {
    DateRangePicker,
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    searchType: {
      type: Number,
      required: false,
      default: () => 0,
    },
    isFlat: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    onDestinationsPage: {
      type: Boolean,
    },
    isDestinySearch: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    activeTab: {
      type: Number,
      required: false,
      default: () => 0,
    },
  },
  data: () => ({
    selectingOutgoing: false,
    selectingReturn: false,
    showDialog: false,
    attrs: "",
    value: {
      startDate: "",
      endDate: "",
    },
    dateRange: {
      startDate: "2021-09-26",
      endDate: "2021-09-28",
    },
    on: "",
    today: new Date().toISOString(),
    localeData: {
      direction: "ltr",
      format: "mm/dd/yyyy",
      separator: " - ",
      applyLabel: "Apply",
      cancelLabel: "Cancel",
      weekLabel: "W",
      customRangeLabel: "Custom Range",
      daysOfWeek: [...daysOfTheWeek[window.appLocale].slice(-1), ...daysOfTheWeek[window.appLocale].slice(0, -1)],
      monthNames: monthNames[window.appLocale],
      firstDay: 1,
    },
    ucfirst,
  }),

  computed: {
    originsOptions() {
      return this.onDestinationsPage
        ? this.$store.state.nights.resources.origins.map(
            ({ id, code, name }) => ({
              id,
              code,
              name,
              label: name,
            })
          )
        : this.$store.getters[GET_MORE_THAN_ONE_DAY_ORIGINS_OPTIONS];
    },
    datesAreInvalid() {
      return this.form.moredaysDate.value.filter(Boolean).length !== 2;
    },
  },

  watch: {
    value: function (val) {
      const start = moment(val.startDate).format("YYYY-MM-DD");
      const end = moment(val.endDate).format("YYYY-MM-DD");
      const range = [start, end || null];
      this.form.moredaysDate.value = [...range];

      this.handleSelectMoreDate([start, end]);
    },
    searchType() {
      this.$nextTick(this.init);
    },
    loading() {
      const { start, end } = this.$route.query;
      this.$store.commit(SET_SEARCH_MORE_START_DATE, moment(start));
      this.$store.commit(SET_SEARCH_MORE_END_DATE, moment(end));
      const origin = this.originsOptions.find(
        ({ code }) => code === this.$route.params.origin
      );
      this.$store.commit(SET_SEARCH_ORIGIN, origin);
    },
    $route: {
      handler(route) {
        if (route.name === "nights-destinations") {
          this.form.moredaysDate.value = [route.query.start, route.query.end];
          this.$store.commit(
            SET_SEARCH_ORIGIN,
            this.originsOptions.find(({ code }) => code === route.params.origin)
          );
        }
      },
      immediate: true,
    },
  },

  methods: {
    toggleCalendar(open) {
      this.selectingOutgoing = open;
    },
    outgoingSelected(value) {
      const date = moment(value, "YYYY-MM-DD");
      this.form.moredaysDate.value = [date];
      this.selectingReturn = true;
      this.selectingOutgoing = false;
      this.setSearchMoreStart(date);
    },
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },
    init() {
      const selectTravellers = this.$el.querySelector(
        ".avm-text-field--travellers .v-input__slot"
      );
      if (selectTravellers) {
        selectTravellers.addEventListener("click", () => {
          this.showDialog = true;
          this.form.showTravellersMenu = true;
        });
      }
      const selectMoreDates = this.$el.querySelector(
        ".avm-text-field--moredates .v-input__slot"
      );
      if (selectMoreDates) {
        selectMoreDates.addEventListener("click", () => {
          this.form.moredaysDate.showMenu = true;
        });
      } else {
        this.form.moredaysDate.showMenu = false;
      }
    },
    allowedDates: (val) => new Date(val) >= new Date(),
    disabledDates: (val) => new Date(vale) <= new Date(),
  },

  mounted() {
    this.init();
    if (
      this.originsOptions.length &&
      this.origin &&
      !this.originsOptions.find(({ code }) => code === this.origin.code)
    ) {
      this.$store.commit(SET_SEARCH_ORIGIN, null);
    }
  },
};
</script>

<style lang="scss">
.date-more-days {
  max-width: 285px !important;
}

.search-form::v-deep {
  .v-date-picker-table {
    height: auto;
  }
}

.datepicker {
  box-shadow: 0 1px 8px 0 rgb(0 0 0 / 23%) !important;
  border-radius: 15px !important;
  border: 1px solid #000000 !important;

  .range {
    .datepicker-controls {
      padding-left: 8px;
      padding-right: 2px;
    }

    .week-days {
      position: relative;
      &::after {
        position: absolute;
        bottom: 2px;
        left: 2.5%;
        width: 95%;
        margin: auto;
        height: 1px;
        content: "";
        background: rgba(0, 0, 0, 0.38);
      }
    }
  }

  .week-days {
    position: relative;
    &::after {
      position: absolute;
      bottom: 2px;
      width: 100%;
      margin: auto;
      height: 0.5px;
      content: "";
      background: rgba(0, 0, 0, 0.38);
    }
    // border-bottom: 1px solid black;

    &-container {
      color: rgba(0, 0, 0, 0.38);
      font-weight: bold;
      font-family: "Avenir";
      text-transform: lowercase;
    }
  }
}

.search-form--more-days {
  .input-container.origin {
    @media (min-width: 1264px) {
      max-width: 310px !important;
    }
  }
}

.max-width-people {
  @media (min-width: 1264px) {
    max-width: 200px !important;
  }
}

.max-width-date {
  @media(max-width: 992px){
    max-width: 100%;
  }
}

.daterangepicker {
  margin-top: 0;
  border-radius: 15px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.23);
  border: solid 1px black;
  padding: 6px;

  &.openscenter {
    @media (max-width: 992px) {
      transform: translate(0) !important;
      position: fixed !important;
      left: 0 !important;
      border-radius: 0 !important;
      top: 0 !important;
      height: 100% !important;
      width: 100% !important;
      border: 0 !important;
      display: flex !important;
      justify-content: space-between;
    }
  }

  th.month {
    font-size: 18px;
    @media (max-width: 992px) {
      font-size: 14px;
    }
  }

  td.disabled {
    text-decoration: none;
  }

  .table-condensed {
    td {
      font-size: 1rem;
      @media (max-width: 992px) {
        font-size: 12px;
        height: 30px;
      }
      height: 41px;
    }
    tbody {
      tr {
        &:first-child {
          border-width: 1.1px !important;
          border: solid #979797;
          border-top: 0;
          border-left: 0;
          border-right: 0;
        }
      }
    }
  }

  .drp-calendar {
    width: 309px;
    max-width: 309px;

    @media (max-width: 992px) {
      width: 100%;
      max-width: 100%;
    }
  }

  &:before,
  &:after {
    display: none;
  }

  .active {
    background-color: #00adbc !important;
  }
}

.date-container {
  max-width: 100% !important;
  display: flex;
  flex-direction: column;

  .reportrange-text {
    background-color: transparent;
    display: flex;
    padding: 0;
    border: 0;
  }
}

.formt-control.reportrange-text {
  display: flex;
}

.v-input{
  position: relative;
  &::after{
    content: "";
    width: 100%;
    height: 50px;
    top: 0;
    left: 0;
    border-radius: 28px;
    position: absolute;
    border: 2px solid black;
    display: none;
  }

  &.rounded-select-selected{
    &:after{
      display: block;
    }
  }
}
</style>
